import React, { useEffect, useState, useContext } from 'react'
import { Box, Text } from "grommet"

import TTJsonTree from '../common/TTJsonTree'
import Spinner from '../common/Spinner'
import TriageUrlContext from '../../context/TriageUrlContext'

import axios from 'axios'

import { gql, useSubscription } from '@apollo/client';

import { FormStatusNotification } from '../common/FormStatusNotification'
import AgDataTable from '../common/AgDataTable'
import UserContext from '../../context/UserContext'
import * as moment from "moment-timezone"

const TASK_QUERY = gql`
subscription($taskId: String!) {
    jobtask(where: {taskid: {_eq: $taskId}}) {
        taskid
        result
        status
      }
}
`

const TriageKibanaView = ({ content }) => {

    const [result, setResult] = useState(false)
    const [resultURL, setResultURL] = useState(false)
    const [state, setState] = useState(false)

    const t3_url = useContext(TriageUrlContext)

    const { data: taskResult, loading: taskDataLoading } = useSubscription(
        TASK_QUERY, { variables: { taskId: content.taskid } }
    )

    let t3TaskStatus = t3_url + '/api/1/taskstatus/' + content.taskid

    async function getStatusResponse() {

        const response = await axios(t3TaskStatus)

        if (response.status === 200) {
            if (response.data.state === "SUCCESS") {
                setResult(response.data)
                setResultURL(response.config.url)
                setState(response.data.state)
                return null
            }
            if (response.data.state === "PENDING") {
                setResult(response.data)
                setResultURL(response.config.url)
                setState(response.data.state)
                return null
            }
            if (response.data.state === "FAILURE") {
                setResult(response.data)
                setResultURL(response.config.url)
                setState(response.data.state)
                return null
            }
        }

    }

    if (!taskDataLoading && taskResult && taskResult.jobtask &&
        taskResult.jobtask.length > 0 && taskResult.jobtask[0].status !== 0
        && !(content.taskid.includes("MANUAL")) && state === false
    ) {
        getStatusResponse()
    }

    const tab_col = [
        {
            field: "timestamp",
            headerName: "Timestamp",
            minWidth: 200,
            sort: 'asc',
            suppressSizeToFit: true,
            wrapText: true,
            autoHeight: true
        },
        {
            field: "node",
            headerName: "Node",
            minWidth: 150,
            suppressSizeToFit: true,
            wrapText: true,
            autoHeight: true
        },
        {
            field: "app",
            headerName: "Application",
            minWidth: 150,
            suppressSizeToFit: true,
            wrapText: true,
            autoHeight: true
        },
        {
            field: "entry",
            headerName: "Entry",
            wrapText: true,
            autoHeight: true,
            minWidth: 150,
        },
    ]

    const [kibanaResult, setkibanaResult] = useState([])
    const token = useContext(UserContext)

    useEffect(() => {
        let final_result = []
        if (result && result.results && result.results.hits && result.results.hits.hits && (result.results.hits.hits).length > 0) {
            (result.results.hits.hits).forEach(result => {

                let timestamp_temp = ''
                timestamp_temp = moment(moment(result['_source']['@timestamp']).format('YYYY-MM-DD HH:mm:ss.SSS') + " +0000").tz('UTC').format('YYYY-MM-DD HH:mm:ss.SSS ZZ')
                timestamp_temp = moment(timestamp_temp).tz(token.timezone).format('YYYY-MM-DD HH:mm:ss.SSS ZZ')

                final_result.push(
                    {
                        "uniqueId": result['_id'],
                        "timestamp": timestamp_temp,
                        "node": result['_source']['host']['name'],
                        "entry": result['_source']['&kv_data'],
                        "app": result['_source']['log']['application'] + (result['_source']['log']['class'] ? "  [" + result['_source']['log']['class'] + "]" : ""),
                    }
                )
            })
        }
        setkibanaResult(final_result)
    }, [result, token.timezone])

    return (
        <>
            <Box margin={{ left: '20px', top: '20px', right: '20px', bottom: '20px' }} gap="small">

                <Box direction="row" gap="small">
                    <Box>
                        <Text weight='bold'>Kibana View</Text>
                    </Box>
                </Box>

                {((content && content.taskid && (content.taskid.includes("MANUAL")) && result) || taskDataLoading) &&
                    <Spinner />
                }

                {
                    !resultURL &&
                    <Spinner />
                }

                <Box>
                    {taskResult && taskResult.jobtask &&
                        taskResult.jobtask.length > 0 && taskResult.jobtask[0].status && taskResult.jobtask[0].status !== 0 &&
                        taskResult.jobtask[0].result && taskResult.jobtask[0].result.length > 0 &&
                        <FormStatusNotification
                            header="Encountered An Error Message From Triage REST API"
                            subheader={taskResult.jobtask[0].result}
                            error={true}
                        />
                    }

                    {!taskDataLoading && content.taskid && content.taskid.indexOf("MANUAL") === -1 && result &&
                        result.results && !result.results.triage_files &&
                        <Box pad="xsmall">
                            <AgDataTable
                                tab_col={tab_col}
                                tab_data={kibanaResult}
                                tableName="kibanaResult"
                                backgroundColor="light-2"
                            />
                        </Box>
                    }
                    {!taskDataLoading && content.taskid && content.taskid.indexOf("MANUAL") === -1 && result &&
                        result.state && result.state === "FAILURE" &&
                        // SHOW FAILURES
                        <TTJsonTree data={result} expandAll={true} />
                    }

                </Box>
            </Box>
        </>
    )
}

export default TriageKibanaView